// ModalContent.tsx
import { FC, isValidElement, ReactNode, useMemo } from "react";

import Icon from "components/Icon/Icon";
import { ClassName } from "config";

import classNames from "classnames";
import { motion } from "framer-motion";
import { isEmpty } from "lodash-es";

import { IModalProps, IModalTransitionVariants } from "./Modal";

interface ModalContentProps {
  variants: IModalTransitionVariants;
  className?: ClassName;
  style?: React.CSSProperties;
  headerProps?: IModalProps["headerProps"];
  confirmExitModal: () => void;
  children?: ReactNode;
  testId?: string;
}

interface ModalHeaderProps extends NonNullable<IModalProps["headerProps"]> {
  onClick?: () => void;
  children?: ReactNode;
}

const ModalHeader: FC<ModalHeaderProps> = ({ icon, className, onClick, closeButton }) => {
  const classes = classNames(className);
  const CloseButton = useMemo(() => {
    if (closeButton) {
      if (isValidElement(closeButton)) {
        return closeButton;
      }
      return (
        <button className="modal-header_close-icon" onClick={onClick}>
          <Icon src={icon} size="sm" />
        </button>
      );
    }
  }, [closeButton, icon, onClick]);

  return <div className={classes}>{CloseButton}</div>;
};

export const ModalContent: React.FC<ModalContentProps> = ({
  className,
  style,
  headerProps,
  confirmExitModal,
  children,
  variants,
  testId,
}) => {
  const classes = classNames("modal-wrapper", className);
  const variantsProps = {
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
    variants,
  };
  return (
    <motion.div style={style} className={classes} data-testid={testId} {...variantsProps}>
      {!isEmpty(headerProps) && <ModalHeader {...headerProps} onClick={confirmExitModal} />}
      {children}
    </motion.div>
  );
};
